

const state = {
    classes: [],
}
const getters = {
    classes(state) {
        return state.classes
    },
    classesSelect(state) {
        return state.classes.map(item=>{
            alert(item)
            return {
                text:item.class_name,
                value:item.class_id
            }
        })
    },
}
const actions = {
    addClass({commit}, subject) {
        commit("addClass",subject)
    },
    getClasses({commit}){
        axios.get(apiRoutes.classes.url).then(response=>{
            // console.log("classes")
            // console.log(response.data.success)
            commit("saveClasses",response.data.success)
        })
    }
}
const mutations = {
    addClass(state,subject) {
        state.classes.push(subject)
    },
    saveClasses(state,subjects){
        state.classes=[...subjects]
    }
}
export default {
    state,
    actions,
    mutations,
    getters
}